// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"bf65978f","787":"9d043335"}[chunkId] + ".chunk.js";
};